import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Typography, TypographyProps } from '@mui/material';
import IncPopover from 'components/inc-popover/inc-popover.component';

export type IncTitleType = {
  popoverIcon?: any;
  popoverContent?: React.ReactNode;
} & TypographyProps;

const IncTitle = ({
  children,
  popoverIcon,
  popoverContent,
  ...rest
}: IncTitleType) => {
  return (
    <>
      <Typography display="flex" alignItems="center" {...rest}>
        {children}
        {!!popoverContent && (
          <Box display="flex" ml="3px" component="span">
            <IncPopover
              PopoverIcon={popoverIcon ?? InfoOutlinedIcon}
              popoverContent={popoverContent}
            />
          </Box>
        )}
      </Typography>
    </>
  );
};

export default IncTitle;
